import React from 'react';

import useDataTable from 'src/shared/components/data-table/hooks/useDataTable';
import styles from 'src/shared/components/data-table/DataTable.module.scss';
import TableRow from '../table-row/TableRow';

const TableBody = () => {
    const { getSortedCurrentPageRows, filteredRows, emptyStateMessage, columns, isSelectable } = useDataTable();

    if (!filteredRows.length && emptyStateMessage) {
        // Add 1 to colspan if table has selectable column
        const colspan = columns.length + (isSelectable ? 1 : 0);
        return (
            <tbody>
                <tr className={`${styles.row} ${styles.rowNoHover}`}>
                    <td colSpan={colspan}>{emptyStateMessage}</td>
                </tr>
            </tbody>
        );
    }

    // Filter the rows that need to be displayed on the current page
    const rowsThisPage = getSortedCurrentPageRows();

    // Columns with columnBanner: when shouldShow is true, show banner spanning all rows
    const bannerColumns = columns.map((column, index) => (column.columnBanner ? index : -1)).filter(index => index !== -1);

    const skipColumns: number[] = [];
    const bannerContents: (React.ReactNode | undefined)[] = [];
    bannerColumns.forEach(columnIndex => {
        const banner = columns[columnIndex].columnBanner;
        if (banner?.shouldShow({ rows: rowsThisPage, columnIndex })) {
            skipColumns.push(columnIndex);
            bannerContents[columnIndex] = banner.content;
        }
    });

    // rowspan for skipped columns should be minumum 2 or total rows in the page
    const rowSpanCount = Math.max(2, rowsThisPage.length);

    return (
        <tbody data-testid='table-body'>
            {rowsThisPage.map((row, index) => {
                const { rowId, cells } = row;

                const isFirstRow = index === 0;
                const rowSpans = isFirstRow
                    ? columns.map((_, columnIndex) => (skipColumns.includes(columnIndex) ? rowSpanCount : 1))
                    : undefined;
                const cellOverrides = isFirstRow
                    ? cells.map((cell, columnIndex) => (skipColumns.includes(columnIndex) ? bannerContents[columnIndex] ?? cell : cell))
                    : cells;

                return (
                    <TableRow
                        key={index}
                        rowData={cellOverrides || []}
                        rowId={rowId as string}
                        rowSpans={rowSpans}
                        skipColumns={!rowSpans ? skipColumns : undefined}
                    />
                );
            })}
        </tbody>
    );
};

export default TableBody;
